var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColombia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000366211 20.0001C0.000366211 8.9545 8.95474 0.00012207 20.0004 0.00012207C31.046 0.00012207 40.0004 8.9545 40.0004 20.0001L20.0004 21.7393L0.000366211 20.0001Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67627 30C6.13447 35.9778 12.5973 40 20 40C27.4028 40 33.8656 35.9778 37.3238 30L20 28.6956L2.67627 30Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3238 30C39.0255 27.0583 40 23.643 40 20H0C0 23.643 0.974532 27.0583 2.67625 30H37.3238Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColombia);
export default __webpack_public_path__ + "static/media/colombia.a4b84f85df5ad9fdaa97dbde932253a7.svg";
export { ForwardRef as ReactComponent };